import { Injectable, inject, signal } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { SKIP_LOADING } from '../interceptors/loading.interceptor';

export type LoadingIndicatorStyle = 'road' | 'logo';

@Injectable({ providedIn: 'root' })
export class LoadingStyleService {
  private http = inject(HttpClient);

  readonly style = signal<LoadingIndicatorStyle>('road');
  private loaded = false;

  load(): void {
    if (this.loaded) return;
    this.loaded = true;
    this.http.get<{ value: string }>('/api/parameters/loading-indicator-style', {
      context: new HttpContext().set(SKIP_LOADING, true),
    }).subscribe({
      next: r => this.style.set(r.value === 'logo' ? 'logo' : 'road'),
      error: () => {},
    });
  }
}
